/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HospitalSettingsApi } from '../api/hospitalsettings.api';

import { HospitalSettingsData, HospitalSettings } from '../../../interfaces/masters/hospitalsettings';

@Injectable()
export class HospitalSettingsService extends HospitalSettingsData {

  constructor(private api: HospitalSettingsApi) {
    super();
  }



  list(url: string): Observable<HospitalSettings[]> {
    return this.api.list(url);
  }
  roomRentList(url: string): Observable<any> {
    return this.api.roomrentlist(url);
  }
  getById(url:string): Observable<HospitalSettings>{
      return this.api.getById(url);
  }

  create(url: string, data:HospitalSettings): Observable<HospitalSettings> {
    console.log('data',data);
    return this.api.add(url,data);
  }

  update(url: string, data:HospitalSettings): Observable<HospitalSettings> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
